import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";



export class ProjectMaintenanceWebApi extends NewviewOaBaseApi {
  public get ControllerName(): any {
    return 'project-maintenance-web'
  }


 

}
